import { render } from "./CertiComponentJa.vue?vue&type=template&id=7525157e&scoped=true"
import script from "./CertiComponentJa.vue?vue&type=script&lang=js"
export * from "./CertiComponentJa.vue?vue&type=script&lang=js"

import "./CertiComponentJa.vue?vue&type=style&index=0&id=7525157e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7525157e"]])

export default __exports__